import { useEffect } from 'react';
import QFFWidget from 'components/QFFWidget';
import { useDispatch } from 'react-redux';
import { setIsSSOLoginScreenVisible } from 'store/authentication/actions';

const QFFWidgetLoginForm = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIsSSOLoginScreenVisible(true));
    return () => dispatch(setIsSSOLoginScreenVisible(false));
  }, [dispatch]);

  return <QFFWidget data-testid="sso-login-form" />;
};

export default QFFWidgetLoginForm;
